export const externalLinks = {
  microsoftTeams: (email: string) => {
    return `https://teams.microsoft.com/l/chat/0/0?users=${email}`;
  },
  mailTo: (email: string) => {
    return `mailto:${email}`;
  },
};
